import { createReducer } from '@reduxjs/toolkit'
import { getSignalStrengthsByUserSuccess } from '../actions/signalService'
import { clearStrengths } from '../actions'

const initialState = []

export const strengths = createReducer(initialState, {
  [clearStrengths.type]: (state, action) => initialState,
  [getSignalStrengthsByUserSuccess.type]: (state, action) => {
    const { signalsList, userId, pageContext } = action.payload
    if (userId === pageContext.id) {
      state.push(...signalsList)
    }
    return state
  },
})
